import React from 'react';
import '../styles/Stats.css';

const Stats = () => {
  const statsData = [
    { number: '20+', label: 'Años de Experiencia' },
    { number: '8', label: 'Regiones del Perú' },
    { number: '100%', label: 'Compromiso' },
    { number: '24/7', label: 'Disponibilidad' }
  ];

  return (
    <section className="stats">
      <div className="stats-container">
        {statsData.map((stat, index) => (
          <div key={index} className="stat-item">
            <span className="stat-number">{stat.number}</span>
            <span className="stat-label">{stat.label}</span>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Stats;
